import { render } from "./MainGame.vue?vue&type=template&id=406184f0&scoped=true&ts=true"
import script from "./MainGame.vue?vue&type=script&lang=ts"
export * from "./MainGame.vue?vue&type=script&lang=ts"

import "./MainGame.vue?vue&type=style&index=0&id=406184f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406184f0"]])

export default __exports__